import bs58 from 'bs58';
import { decodeLongId } from './decodeId';

export function shortenId(id: string): string {
  try {
    return bs58.encode(decodeLongId(id));
  } catch {
    return id;
  }
}
